import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const [active, setActive] = useState('all');

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">分类浏览</h2>
          <p className="text-sm text-foreground-500 mt-2">探索不同类型的热门韩国漫画</p>
        </div>
        <div className="flex items-center justify-center flex-wrap gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={() => setActive(cat.slug)}
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                active === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}